import { forwardRef } from 'react';

/**
 * ハイライト描画用Canvasコンポーネント
 * PDFページ上にハイライトを重ねて表示
 */
const HighlightCanvas = forwardRef(({ highlightsPolygon }, ref) => {
  
    // ハイライト用ポリゴンがない場合は表示しない
  if (!highlightsPolygon || highlightsPolygon.length === 0) {
    return null;
  }

  return (
    <canvas
      ref={ref}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 10,
      }}
    />
  );
});

HighlightCanvas.displayName = 'HighlightCanvas';

export default HighlightCanvas;
